module.exports = __webpack_public_path__ + "static/media/glass-new.a537976c.svg";